var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C7.8615 0 0 7.42884 0 17.4585C0 22.705 2.151 27.2406 5.652 30.3723C5.9445 30.6333 6.1245 31.0023 6.1335 31.3982L6.2325 34.6019C6.264 35.6233 7.317 36.2893 8.253 35.8753L11.826 34.3005C12.1275 34.1655 12.4695 34.143 12.789 34.2285C14.4315 34.6784 16.1775 34.9214 18 34.9214C28.1385 34.9214 36 27.4926 36 17.463C36 7.43334 28.1385 0 18 0Z",
    fill: "url(#paint0_radial_669_14328)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1912 22.5655L12.4787 14.1782C13.3202 12.8419 15.1202 12.5134 16.3847 13.4583L20.5922 16.6125C20.9792 16.9005 21.5102 16.9005 21.8927 16.608L27.5717 12.2974C28.3277 11.7215 29.3177 12.6304 28.8137 13.4358L23.5217 21.8186C22.6802 23.1549 20.8802 23.4834 19.6157 22.5385L15.4082 19.3843C15.0212 19.0963 14.4902 19.0963 14.1077 19.3888L8.4287 23.6994C7.6727 24.2753 6.6827 23.3709 7.1912 22.5655Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_669_14328",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.93 35.8008) scale(39.2256 39.222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6098,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9348,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.5c2f32f0fea3752e3001de3e6b02385a.svg";
export { ForwardRef as ReactComponent };